module.exports = __webpack_public_path__ + "img/chalkboard_tile.827aff06.png";